import { render, staticRenderFns } from "./PreReservation_Regist.vue?vue&type=template&id=1f5210cd&"
import script from "./PreReservation_Regist.vue?vue&type=script&lang=js&"
export * from "./PreReservation_Regist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports